import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';

import { isIOS } from '@shared/utils/is-tablet.util';

import { AppError, ErrorTypes } from '../error/error.model';
import { ErrorService } from '../error/error.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformGuardService implements CanLoad {
  agent = navigator.userAgent || navigator.vendor;
  constructor(private errorService: ErrorService) {}

  // eslint-disable-next-line unused-imports/no-unused-vars
  async canLoad(): Promise<boolean> {
    if (isIOS(this.agent)) {
      return true;
    }

    const message = 'Unable to open page due to incorrect platform';
    this.errorService.add(
      new AppError(ErrorTypes.FORBIDDEN, message, {
        hash: location.hash
      })
    );
    return false;
  }
}
